import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Button from '@mui/material/Button';
import { useSnackbar } from 'notistack';
import { useTranslate, useDataProvider } from 'react-admin';
import SearchIcon from '@mui/icons-material/Search';
import { GET_MANY } from 'ra-core';


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    close: {
        padding: theme.spacing(0.5),
    },
    iconSmall: {
        fontSize: 24,
    },
}));

const CircularIntegration = () => {
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef();
    const translate = useTranslate();
    const dataProvider = useDataProvider();

    const buttonClassname = clsx({
        [classes.buttonSuccess]: success,
    });

    React.useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    function showMessage(message, level) {
        enqueueSnackbar(message, {
            variant: level,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 3000,
        });
    }

    function handleButtonClick() {
        var serialnumber = document.getElementById('serial_number_tim').value;
        if (serialnumber !== "") {
            if (serialnumber && serialnumber.charAt(0) !== '%') {
                serialnumber = '%' + serialnumber;
            }
            setSuccess(false);
            setLoading(true);
            showMessage(translate('tim.getdevice.getting_info'), 'info');

            dataProvider(GET_MANY, 'devices', { "filter": { serial_number_tim: serialnumber, cod_terr_sap: 'GetDeviceAction' } })
                .then(
                    response => {
                        if (response.total > 0) {
                            var user_cod_terr_sap = localStorage.getItem('cod_terr_sap');

                            var foundSameImpresa = function (element) {
                                return element === response.data[0].cod_terr_sap;
                            }

                            if (JSON.parse(user_cod_terr_sap).some(foundSameImpresa) || response.data[0].status.codice === '1') {
                                setSuccess(true);
                                setLoading(false);
                                showMessage(translate('tim.getdevice.success', { id: response.data[0].serial_number_tim }), 'success');

                                window.location.replace(window.location.origin + '/#/devices/' + response.data[0].id);
                            }
                            else {
                                setSuccess(false);
                                setLoading(false);
                                showMessage(translate('tim.validateandsave.caso3'), 'error');
                            }
                        }
                        else {
                            //search if it's not in the Scaricato table
                            dataProvider(GET_MANY, 'devicesScaricato', { "filter": { serial_number_tim: serialnumber, cod_terr_sap: 'GetDeviceAction' } })
                                .then(
                                    response => {
                                        if (response.total > 0) {
                                            setSuccess(true);
                                            setLoading(false);
                                            showMessage(translate('tim.getdevice.success', { id: response.data[0].serial_number_tim }), 'success');

                                            window.location.replace(window.location.origin + '/#/devicesScaricato/' + response.data[0].id);
                                        }
                                        else {
                                            setSuccess(false);
                                            setLoading(false);
                                            showMessage(translate('tim.getdevice.not_found'), 'warning');
                                            //[REQ018 - CASO1] 
                                            var sn = document.getElementById('serial_number_tim').value;
                                            document.getElementById('serial_number_tim').dataset.getdeviceres = sn;
                                            //we update the value twice in order for the field validation to remove the error 
                                            setInputValue(document.getElementById('serial_number_tim'), sn + " ");
                                            setInputValue(document.getElementById('serial_number_tim'), sn);
                                            //we then set the status and anomalia in ValidateAndSave.js
                                        }
                                    })
                                .catch(error => {
                                    setSuccess(false);
                                    setLoading(false);
                                    showMessage(error.message, 'error');
                                });
                        }
                    })
                .catch(error => {
                    setSuccess(false);
                    setLoading(false);
                    showMessage(error.message, 'error');
                });
        }
        else {
            showMessage(translate('tim.getdevice.missing_serialnumber'), 'warning');
        }

    }

    if (window.usingCordova) {
        return (
            <div style={{ display: 'none' }}>
                <div className={classes.root}>
                    <div className={classes.wrapper}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={buttonClassname}
                            disabled={loading}
                            onClick={handleButtonClick}
                            id="GetDeviceButton"
                        >
                            <SearchIcon className={clsx(classes.iconSmall)} />
                        </Button>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div className={classes.root}>
                <div className={classes.wrapper}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={buttonClassname}
                        disabled={loading}
                        onClick={handleButtonClick}
                        id="GetDeviceButton"
                    >
                        <SearchIcon className={clsx(classes.iconSmall)} />
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
            </div>
        )
    }
}

function setInputValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
        valueSetter.call(element, value);
    }
    element.dispatchEvent(new Event('input', { bubbles: true }));
}

export default CircularIntegration;